import clsx from "classnames";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import styles from "./styles.module.scss";

import LatestBlogs from "@/components/LatestBlogs";

function getSlugFromPathname(pathname) {
  const segments = pathname.split("/").filter(Boolean);
  return segments.pop();
}

export default function PostFilters({
  className,
  global,
  pathPrefix,
  post,
  post2,
  page,
  pagePrefix,
  pagePrefixTag,
  origin_post,
  cardPrefix,
  tagPage,
}) {
  const { pathname } = useRouter();
  const slug = getSlugFromPathname(pathname);
  const [firstParam, setFirstParam] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const router = useRouter();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);

  // const [selectedContentType, setSelectedContentType] = useState(pathname.includes("/resources/") ?
  //     slug !== "[url_slug]" ? slug : "All" : "All");
  // const [selectedTag, setSelectTag] = useState(pathname.includes("/resources/tags/") ? `${page.title}` : `All`);

  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    if (sectionRef.current) {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      }, options);

      observer.observe(sectionRef.current);

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileDevice = window.innerWidth <= 991;
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDropdown1 = () => setDropdownOpen1(!dropdownOpen1);
  const toggleDropdown2 = () => setDropdownOpen2(!dropdownOpen2);

  useEffect(() => {
    // Check if the pathname contains at least 3 slashes
    const segments = pathname.split("/").filter(Boolean);
    // Ensure there are at least 3 segments (3 slashes) in the pathname
    if (segments.length >= 3) {
      // Extract the first parameter
      const firstParam = segments[0];
      setFirstParam(firstParam);
      // console.log(firstParam); // This should log 'blog' for '/blog/tags/[url_slug]'
    } else {
      setFirstParam(""); // Clear the state if not enough segments
      // console.log('Pathname does not have enough segments.');
    }
  }, [pathname]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    setIsLoading(true);

    return () => clearTimeout(delayDebounceFn);
  }, [searchKeyword]);

  return (
    post?.length >= 1 && (
      <section ref={sectionRef} className={clsx(className, styles.root)}>
        <Container>
          <div className="d-flex filter-wrapper flex-wrap flex-lg-nowrap">
            <div>
              <div className="label">Search by keywords</div>
              <div className="position-relative">
                <input
                  type="text"
                  id="search"
                  placeholder="Keyword search"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
                {isLoading && <div className="spinner-border" role="status"></div>}
              </div>
            </div>
            <div>
              <div className="label">Filter by Category</div>
              <Dropdown isOpen={dropdownOpen1} toggle={toggleDropdown1}>
                <DropdownToggle caret>
                  {slug == "recorded-training"
                    ? "Recorded-training"
                    : slug == "blog"
                      ? "Blog"
                      : slug == "events"
                        ? "Events"
                        : slug == "downloads"
                          ? "Downloads"
                          : slug == "reviews"
                            ? "Reviews"
                            : pathname === "/resources"
                              ? "All"
                              : firstParam === "resources"
                                ? "All"
                                : firstParam}
                </DropdownToggle>
                {/* <DropdownMenu>
                  {post.map((item, index) => (
                    <DropdownItem key={index}>
                      {tagPage ? (
                        <a href={`/${item.url_slug}/tags/${page.url_slug}`}>{item.title}</a>
                      ) : (
                        <a href={`${pagePrefix}${item.url_slug}`}>{item.title}</a>
                      )}
                    </DropdownItem>
                  ))}
                </DropdownMenu> */}
              </Dropdown>
            </div>
            <div>
              <div className="label">Filter by Tag</div>
              <Dropdown isOpen={dropdownOpen2} toggle={toggleDropdown2}>
                <DropdownToggle caret>
                  {/* {selectedTag} */}
                  {page?.title ? page.title : "All"}
                </DropdownToggle>
                <DropdownMenu>
                  {post2.map((item, index) => (
                    <DropdownItem key={index}>
                      <a
                        href={
                          pathname === "/resources" || pathname.includes("/resources/")
                            ? `/resources/tags/${item.url_slug}`
                            : `${pagePrefixTag}${item.url_slug}`
                        }
                      >
                        {item.title}
                      </a>
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </Container>
        <LatestBlogs
          global={global}
          pathPrefix={`${slug}.resources.page.latest_blogs`}
          post={origin_post}
          heading={``}
          content={``}
          heading_tag={`h3`}
          // cta_title={`View more Insights`}
          // cta_link={`/resources`}
          disable_swiper={true}
          className={`all-post`}
          pagePrefix={cardPrefix}
          searchKeyword={searchKeyword}
        />
      </section>
    )
  );
}

PostFilters.defaultProps = {
  pathPrefix: "",
  className: "",
  pagePrefixTag: "",
};

PostFilters.propTypes = {
  pathPrefix: PropTypes.string,
  className: PropTypes.string,
  pagePrefix: PropTypes.string,
  pagePrefixTag: PropTypes.string,
};
